module.exports = __webpack_public_path__ + "img/7-small.c4993d9a.png";